import { LoginActionTypes } from "./actionTypes";


export const setRefreshTime = (payload: any) => {
  return {type: LoginActionTypes.SET_REFRESH_TOKEN_TIME, payload: payload}
}